module.exports = __webpack_public_path__ + "static/junior-5-d047be589123db0b3b1dfafb048a75cf.png";